module.exports = __webpack_public_path__ + "static/media/tailwind.e0c2e25d.png";